import { Modal, Button } from "@conuti-das/prince-ui";
import { Flex } from "@/ui-prince";
import { useState } from "react";
import { completeJob } from "@/api/jobs";

export function AwaitingUserModal({
  open, onClose, jobId, slashCommand, onComplete,
}: {
  open: boolean; onClose: () => void;
  jobId: string; slashCommand: string;
  onComplete: () => void;
}) {
  const [summary, setSummary] = useState("");
  const [busy, setBusy] = useState(false);
  async function done(failed: boolean) {
    setBusy(true);
    try {
      await completeJob(jobId, { output_summary: summary, failed });
      onComplete();
    } finally { setBusy(false); }
  }
  return (
    <Modal
      isOpen={open}
      title="Claude-Code-Skill ausführen"
      onOpenChange={(isOpen) => { if (!isOpen) onClose(); }}
    >
      <div style={{ padding: "var(--s-4)", display: "flex", flexDirection: "column", gap: "var(--s-3)" }}>
        <p>Diese Stage läuft als Claude-Code-Skill. Bitte folgenden Befehl in Claude Code reinpasten und nach Abschluss "Erledigt" klicken:</p>
        <pre style={{
          background: "#f1f5f9", padding: "var(--s-3)", borderRadius: 6,
          userSelect: "all",
        }}>{slashCommand}</pre>
        <Button variant="plain" onPress={() => navigator.clipboard.writeText(slashCommand)}>
          In Zwischenablage kopieren
        </Button>
        <p>Optional: Zusammenfassung / Notizen</p>
        <textarea className="prn-input" rows={3} value={summary}
          onChange={(e) => setSummary(e.target.value)} />
      </div>
      <Flex justifyContent="End" gap="var(--s-2)" style={{ marginTop: "var(--s-3)" }}>
        <Button variant="tinted" isDisabled={busy} onPress={() => done(true)}>Fehlgeschlagen</Button>
        <Button variant="filled" onPress={onClose}>Abbrechen</Button>
        <Button variant="filled" isDisabled={busy} onPress={() => done(false)}>
          Erledigt
        </Button>
      </Flex>
    </Modal>
  );
}
